const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.hamburgerActive();
        this.contactBtnMove();
        this.subMenu();
    },

    hamburgerActive: function() {
        $(".hamburger").on('click', function() {
            $(".hamburger").toggleClass("hamburger-active");
            $(".site-header__nav-wrapper").toggleClass("site-header__nav-wrapper--open");
            $(".site-header__left").toggleClass("site-header__left--open");
            $(".site-header").toggleClass("site-header__open");
            $(".site-header .social-wrapper").toggleClass("social-wrapper__open");
            $('body').toggleClass("body-hidden");
        });
    },

    contactBtnMove: function() {
        $(window).on('resize', function(){
            resize();
        })

        $(window).on('load', function(){
            resize();
        })
        
        $(document).on('ready', function(){
            resize();
        })
        
        function resize(){
            if($(window).width() < 991)
            {
                // Tablet and Mobile
                $(".site-header__left").appendTo(".main-nav");
            }
        }
    },

    subMenu: function() {
        $('.site-header li.menu-item-has-children a').on('click', function () {
            if($('.site-header li.menu-item-has-children').hasClass('has-children__hover')) {
                $(this).parent().addClass('has-children__hover');
            } else {
                $(this).parent().removeClass('has-children__hover');
            }
            $('.site-header li.menu-item-has-children').toggleClass("has-children__hover");
            // $('.site-header li.has-children ul').not($(this).siblings()).slideDown();
            // $(this).siblings(".site-header li.has-children ul").slideToggle();
        });

        $(document).on("click", function(event){
            if(!$(event.target).closest(".site-header li.menu-item-has-children").length){
                $(".site-header li.has-children ul").slideDown("fast");
            }
        });
    }
}

export default _this;